jQuery(document).ready(function() {
  var elements = jQuery('ul.marquee-item-list li').length;
  for(var i=0;i < elements; i++){
   jQuery(".marquee-item-list").clone().prependTo( ".marquee-block" );
  };
  var liEle = [];
  var liEle = jQuery(".marquee-item-list li");
  jQuery(window).scroll(function() {
	  if (jQuery(this).scrollTop() > 1){  
	    jQuery('.utility-bar').addClass("sticky");
        jQuery('.utility-bar').addClass("sticky");
	  }
	  else{
	    jQuery('.utility-bar').removeClass("sticky");
	  }
	});
  var wordToHide = 'Single Buy';
    
    jQuery('.wsg-variant-row').each(function() {
        if (jQuery(this).text().includes(wordToHide)) {
            jQuery(this).hide();
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 989) {

    const menuItems = document.querySelectorAll(
      '.header__inline-menu details'
    );

    menuItems.forEach(item => {

      item.addEventListener('mouseenter', () => {
        item.setAttribute('open', true);
      });

      item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });

    });
  }
});
